import { render, staticRenderFns } from "./SaaiM3AuditList.vue?vue&type=template&id=0add20fd"
import script from "./SaaiM3AuditList.vue?vue&type=script&lang=js"
export * from "./SaaiM3AuditList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports